import { canDownload, canRead, canWrite } from '../access/rbacAccess'

export const POS = {
  TASKS: 'planifica.pos_tasks',
  EFFECTIVENESS: 'ejecuta.pos_effectiveness',
  ANALYSIS_DOWNLOAD: 'mide.pos_analysis_download'
}

export const canViewPosTasks = () => canRead(POS.TASKS)

export const canManagePosTasks = () => canWrite(POS.TASKS)

export const canViewPosEffectiveness = () => canRead(POS.EFFECTIVENESS)

export const canViewPosAnalysisDownload = () => canRead(POS.ANALYSIS_DOWNLOAD)

export const canDownloadPosAnalysis = () => canDownload(POS.ANALYSIS_DOWNLOAD)
